<style lang="scss" scoped>
::v-deep .table-container {
    max-height: calc(100vh - 220px);
    max-height: calc(var(--vh, 1vh) * 100 - 220px);
}
</style>
<template>
    <div v-if="currentUser.permissions.includes('user.read')">
        <el-table :loading="loading" class="px-0 px-md-44 py-16 py-md-32" :rows="admins" :structure="structure" :searchable="searchable" :meta="tableMeta" @meta-changed="(meta) => { tableMeta = meta; getFilteredAdmins()  }" :server-side-sorting="true" detail="admin-show-admins">
            <template slot="header">
                <div class="col-auto ml-auto">
                    <router-link :to="{ name: 'admin-create-admins' }" class="btn btn-gold btn-sm d-none d-md-block">
                        {{ $t('pages.admins.add_admin') }}
                    </router-link>
                </div>
            </template>
        </el-table>
    </div>
    <div v-else class="container" style="height: calc(100% - 68px)">
        <div class="row h-100">
            <div class="col-auto m-auto">
                <image-no-access height="300"></image-no-access>
                <h4 class="text-primary-dark fw-b text-center mt-32">{{ $t('errors.no_admin_access') }}</h4>
                <p class="text-center">{{ $t('errors.no_admin_access_desc') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ElTable } from '@/components/tables'
export default {
    components: { ElTable },
    data() {
        return {
            loading: false,
            tableMeta: { page: 1 },
            searchable: ['first_name', 'last_name', 'email', 'language'],
            structure: [
                { visible: true, label: this.$t("table.admins.name"), type: 'user', sortable: false },
                { visible: true, label: this.$t("table.admins.email"), type: 'text', key: 'email', sortable: true },
                { visible: true, label: this.$t("table.admins.last_active"), type: 'date', key: 'last_activity', sortable: true },
            ]
        }
    },

    mounted() {
        this.getFilteredAdmins();
    },

    methods: {
        getFilteredAdmins() {
            this.loading = true;
            this.$store.dispatch('admins/index', this.tableMeta).then((p) => {
                this.tableMeta = { ...this.tableMeta, ...p.meta };
                this.loading = false;
            })
        }
    },

    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        admins() {
            return this.$store.getters['admins/all']
        }
    }
}
</script>
